// Runs each reducer in turn over the same state, so a screen can compose
// several reducers (filters, reports, its own) that each handle a disjoint set
// of action types and pass everything else through unchanged.
export const combineReducers =
  <S, A>(...reducers: Array<(state: S, action: A) => S>) =>
  (state: S, action: A): S =>
    reducers.reduce((acc, nextReducer) => nextReducer(acc, action), state);
